import { graphql, useStaticQuery } from "gatsby";

export const useFooterData = () => {
    const data = useStaticQuery(graphql`
        query FOOTER_CONTENT {
            allContentfulHome(filter: { titulo: { eq: "Home Empleo 2.0" } }) {
                nodes {
                    textCentralLlamadas
                    redireccionTitulo
                }
            }
            allContentfulFooter(
                filter: { titulo: { eq: "Footer comfama.com" } }
            ) {
                nodes {
                    titulo
                    categorias {
                        nombreCategoria
                        noVisibleFooter
                        hyperLink
                        referenciaSubcategorias {
                            titulo
                            slug
                            link
                            nombreSubcategoria
                            tipoCampo
                            appStore {
                                title
                                file {
                                    url
                                }
                            }
                            playStore {
                                title
                                file {
                                    url
                                }
                            }
                        }
                    }
                }
            }
            allContentfulMenuLoggin(
                filter: { titulo: { eq: "Menu login comfama.com" } }
            ) {
                nodes {
                    logoGray {
                        title
                        file {
                            url
                        }
                    }
                }
            }
            allContentfulFooterSeccion2(
                filter: { titulo: { eq: "Footer Empleo 2.0" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcion {
                        raw
                    }
                    logoVigiladosHorizontal {
                        title
                        file {
                            url
                        }
                    }
                    logoAsojacas {
                        title
                        file {
                            url
                        }
                    }
                    logoRedPactoGlobal {
                        title
                        file {
                            url
                        }
                    }
                    logoMintrabajo {
                        file {
                            url
                        }
                    }
                    logoProteccionCesante {
                        file {
                            url
                        }
                    }
                    logoServicioDeEmpleo {
                        file {
                            url
                        }
                    }
                    logoAcercaEmplea {
                        file {
                            url
                        }
                    }
                    logoComfama {
                        file {
                            url
                        }
                    }
                    Copyright
                }
            }
        }
    `);

    return data;
};
